import { Avatar } from "radix-ui";
import styles from './css/Avatar.module.css';
import BoySvg from '@/assets/images/avatar-boy-svg.svg';
import GirlSvg from '@/assets/images/avatar-girl-svg.svg';
import { UserInfoResponse } from "@/services/generatedAPIs.schemas";
import {isEN} from "@/utils/i18n";
import { useTranslation } from "react-i18next";

export function AvatarUser({
    user,
    legacy = false,
}: {
    user: UserInfoResponse
    legacy?: boolean
}) {
    const { i18n } = useTranslation();
    return (
        <>
        <Avatar.Root className={styles.AvatarRoot}>
            <div
                className={styles.AvatarImage}
            >
                {
                    user.sex === 'female' ? <img src={GirlSvg} width="70px" height="70px"></img> :
                    user.sex === 'X' ? <div className={styles.AvatarNeutralCircle} /> :
                    <img src={BoySvg} width="70px" height="70px"></img>
                }
            </div>
        </Avatar.Root>
        {/* legacy(非学生)=github/dev：深绿底白字、无 1920 断点。
            学生：≥1920 头像 top 60→95 (logo h=54 + 33px)，姓名 mt 136→171 保持 6px 间距。
            姓名英文回退 user.nameEn 取自 github/dev i18n 修复。 */}
        <div className={["text-base font-semibold text-center", legacy ? "text-white" : "text-sidebar-foreground", legacy ? "mt-34" : "mt-34 min-[1920px]:mt-[171px]"].join(' ')}>{isEN(i18n) ? (user.nameEn || user.name) : user.name}</div>
        <div className={["text-sm text-center", legacy ? "text-slate-100" : "text-sidebar-foreground/60"].join(' ')}>{user.email}</div>
        </>
    )
}